define(['handlebars'], function (handlebars) {

    return function (arg1, options) {
        return (arg1 === null || arg1 === undefined) ? options.fn(this):options.inverse(this);
    }
});
